'use strict';

exports.__esModule = true;
exports.CHOOSE_HOSPITAL_LIST = exports.TOGGLE_HOSPITAL_LIST_MODAL_STATE = exports.TRACK_VIEW_SPECIALIST_PROFILE = exports.SET_LOADING_AUTHED_REVIEWS = exports.SET_HAS_RECEIVED_AUTHED_REVIEWS = exports.LOAD_SPECIALIST_PEER_RECOMMENDATIONS = exports.LOAD_SPECIALIST_AVAILABILITIES = exports.SET_LATEST_AVAILABILITY_FOUND = exports.UDPATE_CALENDAR_START_DATE = exports.LOAD_SPECIALIST_BLOG_POSTS = exports.SET_NEAREST_AVAILABILITY = exports.REMOVE_PATIENT_AVAILABILITY = exports.LOAD_PATIENT_ATTRIBUTES = exports.LOAD_SPECIALIST_PROFILE = exports.TOGGLE_CALENDAR_VIEW = exports.CLEAR_SPECIALIST = exports.TOGGLE_SECTION = exports.TOGGLE_LIKE = exports.INIT_LOADED = exports.LOAD_SPECIALIST_AGGREGATE_REVIEW = exports.LOAD_SPECIALIST_REVIEWS = exports.LOADE_URI = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _doctifyUtils = require('doctify-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOADE_URI = exports.LOADE_URI = 'SPECIALIST_PAGE_ACTIONS:LOADE_URI';
var LOAD_SPECIALIST_REVIEWS = exports.LOAD_SPECIALIST_REVIEWS = 'SPECIALIST_PAGE_ACTIONS:LOAD_SPECIALIST_REVIEWS';
var LOAD_SPECIALIST_AGGREGATE_REVIEW = exports.LOAD_SPECIALIST_AGGREGATE_REVIEW = 'SPECIALIST_PAGE_ACTIONS:LOAD_SPECIALIST_AGGREGATE_REVIEW';
var INIT_LOADED = exports.INIT_LOADED = 'SPECIALIST_PAGE_ACTIONS:INIT_LOADED';
var TOGGLE_LIKE = exports.TOGGLE_LIKE = 'SPECIALIST_PAGE_ACTIONS:TOGGLE_LIKE';
var TOGGLE_SECTION = exports.TOGGLE_SECTION = 'SPECIALIST_PAGE_ACTIONS:TOGGLE_SECTION';
var CLEAR_SPECIALIST = exports.CLEAR_SPECIALIST = 'SPECIALIST_PAGE_ACTIONS:CLEAR_SPECIALIST';
var TOGGLE_CALENDAR_VIEW = exports.TOGGLE_CALENDAR_VIEW = 'SPECIALIST_PAGE_ACTIONS:TOGGLE_CALENDAR_VIEW';
var LOAD_SPECIALIST_PROFILE = exports.LOAD_SPECIALIST_PROFILE = 'SPECIALIST_PAGE_ACTIONS:LOAD_SPECIALIST_PROFILE';
var LOAD_PATIENT_ATTRIBUTES = exports.LOAD_PATIENT_ATTRIBUTES = 'SPECIALIST_PAGE_ACTIONS:LOAD_PATIENT_ATTRIBUTES';
var REMOVE_PATIENT_AVAILABILITY = exports.REMOVE_PATIENT_AVAILABILITY = 'SPECIALIST_PAGE_ACTIONS:REMOVE_PATIENT_AVAILABILITY';
var SET_NEAREST_AVAILABILITY = exports.SET_NEAREST_AVAILABILITY = 'SPECIALIST_PAGE_ACTIONS:SET_NEAREST_AVAILABILITY';
var LOAD_SPECIALIST_BLOG_POSTS = exports.LOAD_SPECIALIST_BLOG_POSTS = 'SPECIALIST_PAGE_ACTIONS:LOAD_SPECIALIST_BLOG_POSTS';
var UDPATE_CALENDAR_START_DATE = exports.UDPATE_CALENDAR_START_DATE = 'SPECIALIST_PAGE_ACTIONS:UDPATE_CALENDAR_START_DATE';
var SET_LATEST_AVAILABILITY_FOUND = exports.SET_LATEST_AVAILABILITY_FOUND = 'SPECIALIST_PAGE_ACTIONS:SET_LATEST_AVAILABILITY_FOUND';
var LOAD_SPECIALIST_AVAILABILITIES = exports.LOAD_SPECIALIST_AVAILABILITIES = 'SPECIALIST_PAGE_ACTIONS:LOAD_SPECIALIST_AVAILABILITIES';
var LOAD_SPECIALIST_PEER_RECOMMENDATIONS = exports.LOAD_SPECIALIST_PEER_RECOMMENDATIONS = 'SPECIALIST_PAGE_ACTIONS:LOAD_SPECIALIST_PEER_RECOMMENDATIONS';
var SET_HAS_RECEIVED_AUTHED_REVIEWS = exports.SET_HAS_RECEIVED_AUTHED_REVIEWS = 'SPECIALIST_PAGE_ACTIONS:SET_HAS_RECEIVED_AUTHED_REVIEWS';
var SET_LOADING_AUTHED_REVIEWS = exports.SET_LOADING_AUTHED_REVIEWS = 'SPECIALIST_PAGE_ACTIONS:SET_LOADING_AUTHED_REVIEWS';
var TRACK_VIEW_SPECIALIST_PROFILE = exports.TRACK_VIEW_SPECIALIST_PROFILE = 'SPECIALIST_PAGE_ACTIONS:TRACK_VIEW_SPECIALIST_PROFILE';
var TOGGLE_HOSPITAL_LIST_MODAL_STATE = exports.TOGGLE_HOSPITAL_LIST_MODAL_STATE = 'SPECIALIST_PAGE_ACTIONS:TOGGLE_HOSPITAL_LIST_MODAL_STATE';
var CHOOSE_HOSPITAL_LIST = exports.CHOOSE_HOSPITAL_LIST = 'SPECIALIST_PAGE_ACTIONS:CHOOSE_HOSPITAL_LIST';

var pageActions = {
	loadSpecialistProfile: function loadSpecialistProfile(specialistId, specialties, hospitalList, network, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'specialists/' + specialistId,
			method: 'GET',
			parameters: { hospitalList: hospitalList, network: network },
			actionType: LOAD_SPECIALIST_PROFILE,
			actionData: {
				specialties: specialties,
				hospitalList: hospitalList,
				network: network
			},
			xhrConfig: xhrConfig
		});
	},
	trackViewsFromSearch: function trackViewsFromSearch(specialistId, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'specialists/' + specialistId + '/track_views_from_search',
			method: 'PUT',
			actionType: TRACK_VIEW_SPECIALIST_PROFILE,
			xhrConfig: xhrConfig
		});
	},
	loadSpecialistReviews: function loadSpecialistReviews(specialistId, offset, auth, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'specialists/' + specialistId + '/reviews',
			method: 'GET',
			parameters: { limit: 50, offset: offset || 0 },
			actionType: LOAD_SPECIALIST_REVIEWS,
			actionData: { firstLoad: !offset || offset === 0 },
			auth: auth,
			xhrConfig: xhrConfig
		});
	},
	loadSpecialistAggregateReview: function loadSpecialistAggregateReview(specialistId, auth, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'specialists/' + specialistId + '/aggregate_review',
			method: 'GET',
			parameters: {},
			actionType: LOAD_SPECIALIST_AGGREGATE_REVIEW,
			auth: auth,
			xhrConfig: xhrConfig
		});
	},
	loadSpecialistPeerRecommendations: function loadSpecialistPeerRecommendations(specialistId, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'specialists/' + specialistId + '/peer_recommendations',
			method: 'GET',
			actionType: LOAD_SPECIALIST_PEER_RECOMMENDATIONS,
			xhrConfig: xhrConfig
		});
	},
	loadSpecialistBlogPosts: function loadSpecialistBlogPosts(specialistId, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'blog/authors/' + specialistId + '/posts',
			method: 'GET',
			parameters: { filters: specialistId },
			actionType: LOAD_SPECIALIST_BLOG_POSTS,
			xhrConfig: xhrConfig
		});
	},
	loadSpecialistAvailabilities: function loadSpecialistAvailabilities(specialistId, parameters, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'specialists/' + specialistId + '/availability',
			method: 'GET',
			parameters: (0, _extends3.default)({}, parameters, {
				for_public_view: true,
				group_by_date: true
			}),
			actionType: LOAD_SPECIALIST_AVAILABILITIES,
			xhrConfig: xhrConfig,
			headers: {
				'Cache-Control': 'no-cache'
			}
		});
	},
	loadPatientAttributes: function loadPatientAttributes(params, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'patients/' + params.id,
			method: 'GET',
			auth: params.auth,
			actionType: LOAD_PATIENT_ATTRIBUTES,
			xhrConfig: xhrConfig
		});
	},
	toggleLike: function toggleLike(_ref) {
		var id = _ref.id,
		    author = _ref.author,
		    auth = _ref.auth;
		return (0, _doctifyUtils.createAction)({
			url: 'reviews/' + id + '/likes',
			method: 'PUT',
			auth: auth,
			data: { author: author, id: id },
			actionType: TOGGLE_LIKE,
			actionData: id
		});
	},
	toggleSection: function toggleSection(toggleValue, sectionName) {
		return {
			type: TOGGLE_SECTION,
			toggleValue: toggleValue,
			sectionName: sectionName
		};
	},
	updateCalendarStartDate: function updateCalendarStartDate(startDate, xhrConfig) {
		return {
			type: UDPATE_CALENDAR_START_DATE,
			startDate: startDate,
			xhrConfig: xhrConfig
		};
	},
	setNearestAvailability: function setNearestAvailability(date) {
		return {
			type: SET_NEAREST_AVAILABILITY,
			date: date
		};
	},
	setLatestAvailabilityFound: function setLatestAvailabilityFound(date) {
		return {
			type: SET_LATEST_AVAILABILITY_FOUND,
			date: date
		};
	},
	toggleCalendarView: function toggleCalendarView(view) {
		return {
			type: TOGGLE_CALENDAR_VIEW,
			view: view
		};
	},
	loadUri: function loadUri(uri, xhrConfig) {
		return {
			type: LOADE_URI,
			uri: uri,
			xhrConfig: xhrConfig
		};
	},
	initLoaded: function initLoaded() {
		return {
			type: INIT_LOADED
		};
	},
	clearSpecialist: function clearSpecialist() {
		return {
			type: CLEAR_SPECIALIST
		};
	},
	setHasReceivedAuthedReviews: function setHasReceivedAuthedReviews() {
		return {
			type: SET_HAS_RECEIVED_AUTHED_REVIEWS
		};
	},
	setLoadingAuthedReviews: function setLoadingAuthedReviews(status) {
		return {
			type: SET_LOADING_AUTHED_REVIEWS,
			status: status
		};
	},
	toggleModalState: function toggleModalState(openState) {
		return {
			type: TOGGLE_HOSPITAL_LIST_MODAL_STATE,
			isHospitalListModalOpen: openState
		};
	},
	chooseHospitalList: function chooseHospitalList(hospitalList) {
		return {
			type: CHOOSE_HOSPITAL_LIST,
			hospitalList: hospitalList
		};
	}
};

exports.default = pageActions;


// WEBPACK FOOTER //
// ./components/specialist-page/lib/actions/page-actions.js